<datex-grid #$gridComponent *ngIf="initialized && !$hasMissingRequiredInParams"  [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"
[canEdit]="canEdit"


>
    <ng-container topToolbar>
    <div class="query-filter">
      <input
        matInput
        [(ngModel)]="fullTextSearch" 
        (ngModelChange)="reload()" 
        [ngModelOptions]="{updateOn: 'blur'}"
        autocomplete="off"
        class="datex-textbox query-search"
        spellcheck="false"
        placeholder="Filter"
        [matTooltip]="fullTextSearch"
        matTooltipClass="datex-control-tooltip">
    </div>
  </ng-container>


  <ng-container gridColumnDef="linenumber">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.linenumber.displayControl.styles.style"
          [ngClass]="row.cells.linenumber.displayControl.styles.classes"
          [matTooltip]="row.cells.linenumber.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.linenumber.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="material">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.material.displayControl.styles.style"
          [ngClass]="row.cells.material.displayControl.styles.classes"
          [matTooltip]="row.cells.material.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.material.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="vendorlot">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.vendorlot.displayControl.styles.style"
          [ngClass]="row.cells.vendorlot.displayControl.styles.classes"
          [matTooltip]="row.cells.vendorlot.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.vendorlot.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="lot">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.lot.displayControl.styles.style"
          [ngClass]="row.cells.lot.displayControl.styles.classes"
          [matTooltip]="row.cells.lot.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.lot.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="packaging">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.packaging.displayControl.styles.style"
          [ngClass]="row.cells.packaging.displayControl.styles.classes"
          [matTooltip]="row.cells.packaging.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.packaging.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="packaged_amount">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.packaged_amount.displayControl.styles.style"
          [ngClass]="row.cells.packaged_amount.displayControl.styles.classes"
          [matTooltip]="row.cells.packaged_amount.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.packaged_amount.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="purchase_order_identifier">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.purchase_order_identifier.displayControl.styles.style"
          [ngClass]="row.cells.purchase_order_identifier.displayControl.styles.classes"
          [matTooltip]="row.cells.purchase_order_identifier.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.purchase_order_identifier.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['purchase_order_identifier_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.purchase_order_identifier.editControl.readOnly || row.cells.purchase_order_identifier.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.purchase_order_identifier.editControl.placeholder}}"
            [ngStyle]="row.cells.purchase_order_identifier.editControl.styles.style"
            [ngClass]="row.cells.purchase_order_identifier.editControl.styles.classes"
            [matTooltip]="row.cells.purchase_order_identifier.editControl.tooltip"
            matTooltipClass="datex-control-tooltip"> 
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="residue_hold_identifier">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.residue_hold_identifier.displayControl.styles.style"
          [ngClass]="row.cells.residue_hold_identifier.displayControl.styles.classes"
          [matTooltip]="row.cells.residue_hold_identifier.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.residue_hold_identifier.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['residue_hold_identifier_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.residue_hold_identifier.editControl.readOnly || row.cells.residue_hold_identifier.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.residue_hold_identifier.editControl.placeholder}}"
            [ngStyle]="row.cells.residue_hold_identifier.editControl.styles.style"
            [ngClass]="row.cells.residue_hold_identifier.editControl.styles.classes"
            [matTooltip]="row.cells.residue_hold_identifier.editControl.tooltip"
            matTooltipClass="datex-control-tooltip"> 
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="establishment_identifier">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.establishment_identifier.displayControl.styles.style"
          [ngClass]="row.cells.establishment_identifier.displayControl.styles.classes"
          [matTooltip]="row.cells.establishment_identifier.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.establishment_identifier.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['establishment_identifier_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.establishment_identifier.editControl.readOnly || row.cells.establishment_identifier.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.establishment_identifier.editControl.placeholder}}"
            [ngStyle]="row.cells.establishment_identifier.editControl.styles.style"
            [ngClass]="row.cells.establishment_identifier.editControl.styles.classes"
            [matTooltip]="row.cells.establishment_identifier.editControl.tooltip"
            matTooltipClass="datex-control-tooltip"> 
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="material_alias">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.material_alias.displayControl.styles.style"
          [ngClass]="row.cells.material_alias.displayControl.styles.classes"
          [matTooltip]="row.cells.material_alias.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.material_alias.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['material_alias_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.material_alias.editControl.readOnly || row.cells.material_alias.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.material_alias.editControl.placeholder}}"
            [ngStyle]="row.cells.material_alias.editControl.styles.style"
            [ngClass]="row.cells.material_alias.editControl.styles.classes"
            [matTooltip]="row.cells.material_alias.editControl.tooltip"
            matTooltipClass="datex-control-tooltip"> 
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="marks">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.marks.displayControl.styles.style"
          [ngClass]="row.cells.marks.displayControl.styles.classes"
          [matTooltip]="row.cells.marks.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.marks.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['marks_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.marks.editControl.readOnly || row.cells.marks.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.marks.editControl.placeholder}}"
            [ngStyle]="row.cells.marks.editControl.styles.style"
            [ngClass]="row.cells.marks.editControl.styles.classes"
            [matTooltip]="row.cells.marks.editControl.tooltip"
            matTooltipClass="datex-control-tooltip"> 
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="size">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.size.displayControl.styles.style"
          [ngClass]="row.cells.size.displayControl.styles.classes"
          [matTooltip]="row.cells.size.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.size.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['size_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.size.editControl.readOnly || row.cells.size.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.size.editControl.placeholder}}"
            [ngStyle]="row.cells.size.editControl.styles.style"
            [ngClass]="row.cells.size.editControl.styles.classes"
            [matTooltip]="row.cells.size.editControl.tooltip"
            matTooltipClass="datex-control-tooltip"> 
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="color">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.color.displayControl.styles.style"
          [ngClass]="row.cells.color.displayControl.styles.classes"
          [matTooltip]="row.cells.color.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.color.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['color_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.color.editControl.readOnly || row.cells.color.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.color.editControl.placeholder}}"
            [ngStyle]="row.cells.color.editControl.styles.style"
            [ngClass]="row.cells.color.editControl.styles.classes"
            [matTooltip]="row.cells.color.editControl.tooltip"
            matTooltipClass="datex-control-tooltip"> 
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="style">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.style.displayControl.styles.style"
          [ngClass]="row.cells.style.displayControl.styles.classes"
          [matTooltip]="row.cells.style.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.style.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['style_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.style.editControl.readOnly || row.cells.style.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.style.editControl.placeholder}}"
            [ngStyle]="row.cells.style.editControl.styles.style"
            [ngClass]="row.cells.style.editControl.styles.classes"
            [matTooltip]="row.cells.style.editControl.tooltip"
            matTooltipClass="datex-control-tooltip"> 
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
<div *ngIf="$hasMissingRequiredInParams" class="missing-params">
  <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
</div>
